import attachmentImg from "Assets/images/file-type/image.svg";
import DocThumbnail from "Assets/images/file-type/document.svg";
import PdfThumbnail from "Assets/images/file-type/pdf.svg";
import XlsThumbnail from "Assets/images/file-type/excel.svg";
import PptThumbnail from "Assets/images/file-type/presentation.svg";
import AudioThumbnail from "Assets/images/file-type/audio.svg";
import VideoThumbnail from "Assets/images/file-type/video.svg";
import TextThumbnail from "Assets/images/file-type/text.svg";
import LinkThumbnail from "Assets/images/file-type/other-types.svg";

import mime from "mime-types";
import { get, isEmpty, isString } from "lodash";
import { Auth } from "aws-amplify";
import formateUserName from "./formateUserName";
import { USERPROFILE } from "../constants/routeConstants";
import { REGEX_URL } from "../constants";

const optionLabelValue = (items) => {
  return (items || []).map((res) => {
    return { name: res, value: res };
  });
};

const getFileTypeByKey = (key) => {
  const array = key ? key.split("/") : "";
  const fileName = array[array.length - 1];
  return mime.contentType(fileName);
};

const displayAttachmentText = (type) => {
  switch (type) {
    case "image":
      return "View image";
    case "application":
      return "Read attachment";
    case "audio":
      return "Listen to audio";
    case "video":
      return "Watch video";
    case "link":
      return "View link";
    default:
      return "Attachment";
  }
};

const defaultAttachmentImage = (key, link) => {
  let name = "";
  let attachmentType = "";
  let selectedFileImage = DocThumbnail;
  const type = getFileTypeByKey(get(link, "fileName", "") || key);
  if (isString(link)) {
    name = link;
    attachmentType = "link";
    selectedFileImage = LinkThumbnail;
  } else if (type && type.startsWith("application/vnd")) {
    if (type.includes("document")) {
      attachmentType = "application";
      selectedFileImage = DocThumbnail;
    }
    if (type && (type.includes("excel") || type.includes("spreadsheet"))) {
      attachmentType = "application";
      selectedFileImage = XlsThumbnail;
    }
    if (type && type.includes("presentation")) {
      attachmentType = "persentation";
      selectedFileImage = PptThumbnail;
    }
    if (type && type.includes("application/vnd.ms-powerpoint")) {
      attachmentType = "persentation";
      selectedFileImage = PptThumbnail;
    }
  } else if (type && type.startsWith("application/pdf")) {
    attachmentType = "application";
    selectedFileImage = PdfThumbnail;
  } else if (type && type.startsWith("audio/")) {
    attachmentType = "audio";
    selectedFileImage = AudioThumbnail;
  } else if (type && type.startsWith("video/")) {
    attachmentType = "video";
    selectedFileImage = VideoThumbnail;
  } else if (
    type &&
    (type.startsWith("image/jp") || type.startsWith("image/png"))
  ) {
    attachmentType = "image";
    selectedFileImage = get(link, "url", attachmentImg);
  } else if (type && type.startsWith("image/")) {
    attachmentType = "image";
    selectedFileImage = get(link, "url") || attachmentImg;
  } else if (type && type.startsWith("text/plain")) {
    attachmentType = "text";
    selectedFileImage = TextThumbnail;
  } else if (type && type.startsWith("text/csv")) {
    attachmentType = "text";
    selectedFileImage = XlsThumbnail;
  }
  return {
    selectedFileImage,
    attachmentType,
    name,
  };
};

const generalCheckinFileType = (key) => {
  let attachmentType = "";
  const type = getFileTypeByKey(key);
  if (type.startsWith("application/vnd")) {
    attachmentType = "EXCEL";
  } else if (type.startsWith("application/pdf")) {
    attachmentType = "PDF";
  } else if (type.startsWith("audio/")) {
    attachmentType = "AUDIO";
  } else if (type.startsWith("video/")) {
    attachmentType = "VIDEO";
  } else if (type.startsWith("image/jp")) {
    attachmentType = "IMAGE";
  } else if (type.startsWith("image/")) {
    attachmentType = "IMAGE";
  }
  return attachmentType;
};

const getExtensionFromFileName = (str) => str.slice(1 + str.lastIndexOf("."));

const getFileContentype = (fileName) => {
  const extension = getExtensionFromFileName(fileName);
  if (excelFileTypes.includes(extension)) {
    return { type: "EXCEL", contentType: "application/vnd.ms-excel" };
  } else if (documentFileTypes.includes(extension)) {
    return { type: "DOCUMENT", contentType: "application/msword" };
  } else if (pdfFileTypes.includes(extension)) {
    return { type: "PDF", contentType: "application/pdf" };
  } else if (pptFileTypes.includes(extension)) {
    return { type: "PPT", contentType: "application/vnd.ms-powerpoint" };
  } else if (imageFileTypes.includes(extension)) {
    return { type: "IMAGE", contentType: "image/jpeg, image/png" };
  }
  // else if (audioFileTypes.includes(extension)) {
  //   return { type: "AUDIO", contentType: "audio/mpeg, audio/mp4" };
  // }
  else if ([...audioFileTypes, ...videoFileTypes].includes(extension)) {
    return {
      type: "VIDEO",
      contentType:
        "audio/mpeg, audio/mp4, video/mp4,video/ogg,video/x-ms-wmv,application/x-mpegurl,video/x-msvideo,video/ms-asf,video/x-m4v,video/webm,video/quicktime,video/mpeg,video/3gpp,application/vnd.apple.mpegurl",
    };
  }
  return {
    type: null,
  };
};

const getCheckinDetailsUtils = (item) => {
  switch (item.checkInType) {
    case "TEXT":
      return item.textCheckin;
    case "LINK":
      return item.linkCheckin;
    case "SURVEY":
    case "TEST":
    case "QUESTION":
      return item.surveyCheckin;
    case "MULTIMEDIA":
      return item.multimediaCheckin;
    case "EVENT":
      return item.eventCheckin;
    default:
      break;
  }
};

const getUserId = () =>
  get(Auth, "user.attributes.custom:userId", "") ||
  get(Auth, "user.username", "");

const getCompanyId = () => get(Auth, "user.attributes.custom:companyId", "");

const getUserRole = () => get(Auth, "user.attributes.custom:role");

const checkStringLength = (literal) => {
  return (literal || "").length;
};

const checkArrayLength = (arrayData) => {
  return (arrayData || []).length;
};

const getDataFromPublicApi = async (url) => {
  try {
    return await fetch(url);
  } catch (error) {
    console.log(error);
  }
};
const generateOptionData = (res) => {
  if (isEmpty(res)) {
    return {};
  }
  return {
    title: `${formateUserName(res.firstName)} ${formateUserName(res.lastName)}`,
    value: `${formateUserName(res.firstName)} ${formateUserName(res.lastName)}`,
    profileImage: get(res, "profileImage.fileName", ""),
    fullName: `${formateUserName(res.firstName)} ${formateUserName(
      res.lastName
    )}`,
    fnLowerCase: `${formateUserName(res.firstName)} ${formateUserName(
      res.lastName
    )}`?.toLowerCase(),
    firstName: formateUserName(res.firstName),
    lastName: formateUserName(res.lastName),
    id: get(res, "userid", "") ? res.userid : res.id,
    name: get(res, "userid", "") ? res.userid : res.id,
    status: res?.status,
  };
};

const dateInBetween = (from, to, check) => {
  if (
    Date.parse(check) <= Date.parse(to) &&
    Date.parse(check) >= Date.parse(from)
  ) {
    return true;
  }
  return false;
};
const IsJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const userProfile = (userId, history) => {
  return history.push(`${USERPROFILE}/${userId}`);
};

// add find link and add anchor tag
const findAndReplaceAnchor = (text) => {
  var urlRegex = REGEX_URL;
  return text.replace(urlRegex, function (url) {
    return (
      '<a target=”_blank” rel="noreferrer noopener" href="' +
      url +
      '">' +
      url +
      "</a>"
    );
  });
};
const removeTypeName = (data) => {
  return (data || []).map((res) => {
    let data = { ...res };
    data && data.__typename && delete data.__typename;
    return data;
  });
};

const isValidURL = (string) => {
  const httpRegex =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  return httpRegex.test(string);
};

export const getBase64File = (file, setValue, name) => {
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    setValue && setValue(name, reader.result);
  };
  reader.onerror = function (error) {
    console.log("Error: ", error);
  };
};
const videoFileTypes = [
  "m3u",
  "m3u8",
  "mp4",
  "m4a",
  "m4p",
  "m4b",
  "m4r",
  "m4v",
  "m1v",
  "ogg",
  "mov",
  "qt",
  "webm",
  "asf",
  "wma",
  "wmv",
  "avi",
];
const audioFileTypes = ["mp3", "wav", "mp4", "wma", "webm"];
const imageFileTypes = ["jpeg", "jpg", "JPG", "png", "PNG", "bmp"];
const pptFileTypes = ["ppt", "pptx", "odp"];
const documentFileTypes = ["doc", "docx", "odt", "rtf", "txt"];
const excelFileTypes = ["xls", "xlsx", "ods", "csv"];
const pdfFileTypes = ["pdf"];
const removeHtmlTag = (str) => {
  // Remove HTML comments
  if (str) {
    var withoutComments = str.replace(/<!--[\s\S]*?-->/g, "");

    // Remove Word-specific XML comments and metadata
    withoutComments = withoutComments.replace(/<o:.*?>|<w:.*?>|<m:.*?>/g, "");

    let withoutHtml = withoutComments.replace(/<[^>]*>/g, "");

    // Remove CSS styles
    withoutHtml = withoutHtml.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");

    return withoutHtml;
  }
  return "";
};
export {
  optionLabelValue,
  defaultAttachmentImage,
  getFileTypeByKey,
  getCheckinDetailsUtils,
  generalCheckinFileType,
  getUserId,
  getCompanyId,
  getUserRole,
  checkStringLength,
  checkArrayLength,
  getFileContentype,
  getDataFromPublicApi,
  generateOptionData,
  dateInBetween,
  userProfile,
  IsJsonString,
  findAndReplaceAnchor,
  removeTypeName,
  isValidURL,
  displayAttachmentText,
  videoFileTypes,
  audioFileTypes,
  imageFileTypes,
  pptFileTypes,
  documentFileTypes,
  excelFileTypes,
  pdfFileTypes,
  getExtensionFromFileName,
  removeHtmlTag,
};
